import { render, staticRenderFns } from "./UIDiscount.vue?vue&type=template&id=1b5f5671&"
import script from "./UIDiscount.vue?vue&type=script&lang=js&"
export * from "./UIDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports